import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Card } from "@mui/material";
import { useParams, useSearchParams } from 'react-router-dom';
import PropTypes from "prop-types";
import { formCardStyle } from '../../TransitionStyles';
import { FacilityInformationFormTitles } from '../../formTitlesLists';
import { trimData } from '../../../../../utils/formatText';
import { getFacilityInformationData, saveFacilityInformationForm } from '../../../../../api/transitions';
import { enqueueSnackbar } from '../../../../../reusable-components/snackbar';
import SkeletonBlock from '../../SkeletonBlock';
import FormBuilder from '../../FormBuilder';
import { flattenTransitionSubmitData } from '../../formDataUtils';

const FacilityInformationView = forwardRef(({ setFormData }, ref)=> { 
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('facilityId');
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFacilityInformationData(id, facilityId ?? 0)
      .then((resp) => {
        setData(resp.data);
      })
      .catch(() => {
        enqueueSnackbar('Failed to load data', { variant: 'error' });
      })
      .finally(() => {
        setIsLoading(false)
      });
  }, [id, facilityId]);

  useEffect(() => {
    const mappedFields = {
      ...data?.generalInformationFields?.reduce((acc, field) => ({ ...acc, [field.fieldName]: field.answer }), {}),
      ...data?.sellerInformationFields?.reduce((acc, field) => ({ ...acc, [field.fieldName]: field.answer }), {}),
      ...data?.buyerInformationFields?.reduce((acc, field) => ({ ...acc, [field.fieldName]: field.answer }), {}),
      ...data?.additionalFilesFields?.reduce((acc, field) => ({ ...acc, [field.fieldName]: field.answer }), {}),
      ...data?.administrativeStaffFields?.reduce((acc, field) => ({ ...acc, [field.fieldName]: field.answer }), {}),
    };

    setFormData({ transitionFacilityId: data?.transitionFacilityId,  ...mappedFields })
  }, [data]);

  const submitForm = async (allData) => {
    const flattenData = flattenTransitionSubmitData(allData);
    const result = trimData(flattenData);

    await saveFacilityInformationForm({ id,  sellerFacilityId: facilityId,...result })
      .then((resp) => {
        enqueueSnackbar('Facility Information data saved successfully', { variant: 'success' });
        setData(resp.data);
      })
      .catch(() => {
        enqueueSnackbar('Failed to save Facility Information data', { variant: 'error' });
      });
  };

  useImperativeHandle(ref, () => ({ submitForm }));

  return isLoading ? <SkeletonBlock height={600} sx={{ mt: 2 }} />
    : ( 
    FacilityInformationFormTitles?.map((form) => (
      <Card key={form.title} sx={formCardStyle}>
        <FormBuilder
          formName={form.title}
          fields={data?.[form.fieldsTitle]}
        />
      </Card>
    )))
});

export default FacilityInformationView;

FacilityInformationView.propTypes = {
  setFormData: PropTypes.func
}